import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 36px;
  height: 36px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  "aria-label": "substituut voor een avatar"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: "18",
  cy: "23",
  r: "18"
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: "0",
  y: "5",
  width: "36",
  height: "36"
})), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, -5)"
}, /*#__PURE__*/React.createElement("mask", {
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  href: "#path-1"
}), /*#__PURE__*/React.createElement("mask", {
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  href: "#path-3"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#CC0000",
  mask: "url(#mask-4)",
  transform: "translate(19.413278, 14.294640) rotate(57) translate(-19.413278, -14.294640)",
  x: "4.91327771",
  y: "11.2946403",
  width: "29",
  height: "6"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#CC0000",
  mask: "url(#mask-4)",
  transform: "translate(17.500000, 23) rotate(-30) translate(-17.500000, -23)",
  x: "3",
  y: "20",
  width: "29",
  height: "6"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#CC0000",
  mask: "url(#mask-4)",
  transform: "translate(17, 34) rotate(-83) translate(-17, -34)",
  x: "2.5",
  y: "31",
  width: "29",
  height: "6"
})))));